<template>
  <div v-bind:class="dialogClassName">
    <div class="dialog-overlay"></div>
    <div class="dialog-content exam-explanation" v-if="hasExam">
      <a
        class="close"
        :style="{
          backgroundColor: iconCloseColor,
          color: buttonCloseColor,
          visibility: 'unset !important',
          opacity: '1',
        }"
        v-on:click="close"
      >
        <i class="lni lni-close"></i>
      </a>
      <section class="detail">
        <div class="scroll-box">
          <div class="box exam-title">
            <i class="lni lni-pencil-alt black-text mb-2"></i>
            <h2 class="black-text mb-0">{{ title }}</h2>

            <v-row>
              <v-col cols="12">
                <p
                  v-if="detail.description != ''"
                  class="subtitle-1 mb-0 ma-auto"
                  hide-details
                  v-html="'คำชี้แจง ' + detail.description"
                ></p>
                <v-card class="ma-auto" max-width="500">
                  <v-list-item class="pa-3">
                    <v-list-item-content class="pa-0">
                      <v-list-item-title class="ma-0">
                        <p>จำนวนคำถาม</p>
                        <p>คะแนนเต็ม</p>
                        <p>การจับเวลา</p>
                        <p>จำนวนครั้งที่สอบ</p>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action class="subtitle-1 ma-0 text-right">
                      <v-list-item-title>
                        <p>
                          {{ detail.totalQuestion + " คำถาม" }}
                        </p>
                        <p>{{ detail.totalScore + " คะแนน" }}</p>
                        <p>
                          {{
                            detail.timeUse != 0
                              ? millisecToHr(detail.timeUse) + " ชั่วโมง"
                              : "ไม่จับเวลา"
                          }}
                        </p>
                        <p>
                          {{ detail.term }} ครั้ง /
                          {{
                            detail.limited == 0 ? "ไม่จำกัด" : detail.limited
                          }}
                        </p>
                      </v-list-item-title>
                    </v-list-item-action>
                  </v-list-item>
                </v-card>
              </v-col>
              <v-col cols="12">
                <h3 class="title text-center black--text">สถิติการสอบของฉัน</h3>
                <p
                  v-if="myTicket.length == 0"
                  class="subtitle-1 text-center grey--text mt-5"
                >
                  ยังไม่มีประวัติการสอบ
                </p>
                <v-card v-else class="ma-auto" max-width="500">
                  <apexchart
                    type="bar"
                    height="250"
                    :options="examAvgChartOptions"
                    :series="examAvgSeries"
                  ></apexchart>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" class="text-center pa-0">
                <v-card-text class="pa-1">
                  <p class="title mb-0">
                    {{ myTicket.length == 0 ? "-" : getMaxScore(myTicket) }}
                  </p>
                  <p class="subtitle-1 mb-0">คะแนนสูงสุด</p>
                </v-card-text>
              </v-col>
              <v-col cols="4" class="text-center pa-0">
                <v-card-text class="pa-1">
                  <p class="title mb-0">
                    {{ myTicket.length == 0 ? "-" : getMinScore(myTicket) }}
                  </p>
                  <p class="subtitle-1 mb-0">คะแนนต่ำสุด</p>
                </v-card-text>
              </v-col>
              <v-col cols="4" class="text-center pa-0">
                <v-card-text class="pa-1">
                  <p class="title mb-0">
                    {{ myTicket.length == 0 ? "-" : getLastScore(myTicket) }}
                  </p>
                  <p class="subtitle-1 mb-0">คะแนนล่าสุด</p>
                </v-card-text>
              </v-col>
            </v-row>
            <!-- <ul class="general-list center">
              <li>
                <p>
                  <span>จำนวนคำถาม</span>
                  <span>{{ detail.questions.length }} คำถาม</span>
                </p>
              </li>
              <li>
                <p>
                  <span>คะแนนเต็ม</span>
                  <span>{{ detail.totalScore }} คะแนน</span>
                </p>
              </li>
              <li>
                <p>
                  <span>การจับเวลา</span>
                  <span v-if="detail.timeUse != 0"
                    >{{ millisecToHr(detail.timeUse) }} ชั่วโมง</span
                  >
                  <span v-if="detail.timeUse == 0">ไม่จับเวลา</span>
                </p>
              </li>
              <li>
                <p>
                  <span>จำนวนครั้งที่สอบ</span>
                  <span
                    >{{ detail.term }} ครั้ง /
                    {{
                      detail.limited == 0 ? "ไม่จำกัด" : detail.limited
                    }}</span
                  >
                </p>
              </li>
            </ul> -->
          </div>
          <!-- <div class="box">
            <h3>คำชี้แจง</h3>
            <ul class="general-list">
              <li>
                <p>- แบบทดสอบนี้เป็นแบบปรนัยชนิดเลือกตอบ 4 ตัวเลือก จำนวน 10 ข้อ 10 คะแนน</p>
              </li>
              <li>
                <p>- ให้นักเรียนเลือกคำตอบที่ถูกต้องที่สุดเพียงข้อเดียวแล้วทำเครื่องหมาย x ลงในกระดาษคำตอบ</p>
              </li>
              <li>
                <p>- เวลาที่ใช้ในการทำแบบทดสอบ 10 นาที</p>
              </li>
            </ul>
          </div>-->
        </div>
        <button class="size-xl disable" v-if="statusCode == 'UNPUBLISHED'">
          ข้อสอบยังไม่เปิดให้ใช้งาน
        </button>
        <button class="size-xl disable" v-else-if="statusCode == 'TOO_EARLY'">
          ยังไม่ถึงเวลาการทำข้อสอบ
        </button>
        <button class="size-xl disable" v-else-if="statusCode == 'OVERDUE'">
          หมดเวลาการทำข้อสอบ
        </button>
        <button
          class="size-xl disable"
          v-else-if="statusCode == 'LIMIT_EXCEED'"
        >
          จำนวนครั้งในการทำข้อสอบหมดแล้ว
        </button>
        <button class="size-xl disable" v-else-if="statusCode == null">
          กรุณารอซักครู่
        </button>
        <button
          class="size-xl"
          :style="{ backgroundColor: buttonColor }"
          v-else
          v-on:click="goToExamWeb"
        >
          ทำแบบทดสอบ
        </button>
      </section>
      <section class="summary scroll-box">
        <!-- <h3 class="title text-center black--text mt-10">สถิติการสอบโดยรวม</h3>
        <v-card class="mx-auto pa-3" max-width="100%">
          <v-list-item class="pa-3">
            <v-list-item-content class="pa-0">
              <v-list-item-title class="ma-0">
                <p>จำนวนผู้เข้าสอบ</p>
                <p>คะแนนเต็ม</p>
                <p>คะแนนสูงสุด</p>
                <p>คะแนนต่ำสุด</p>
                <p>คะแนนเฉลี่ย</p>
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action class="subtitle-1 ma-0 text-right">
              <v-list-item-title>
                <p>
                  {{ detail.rankstat.numplayer + " คน" }}
                </p>
                <p>{{ detail.totalScore + " คะแนน" }}</p>
                <p>
                  {{ detail.rankstat.max + " คะแนน" }}
                </p>
                <p>
                  {{ detail.rankstat.min }}
                  {{ detail.myTicket ? detail.myTicket + " คะแนน" : " คะแนน" }}
                </p>
                <p>
                  {{
                    detail.rankstat.mean % 1 === 0
                      ? detail.rankstat.mean
                      : detail.rankstat.mean.toFixed(2) + " คะแนน"
                  }}
                </p>
              </v-list-item-title>
            </v-list-item-action>
          </v-list-item>
        </v-card> -->
        <h3 class="title text-center black--text mt-6">ประวัติการสอบของฉัน</h3>
        <p
          v-if="myTicket.length == 0"
          class="subtitle-1 text-center grey--text mt-5"
        >
          ยังไม่มีประวัติการสอบ
        </p>
        <div v-for="exam in myTicket" :key="exam._id">
          <v-card class="mt-3 mx-auto pa-3" max-width="100%">
            <v-list-item>
              <v-list-item-content class="pa-0">
                <v-list-item-title class="ma-0">
                  <p class="grey--text">สอบครั้งที่</p>
                  <p>วันที่</p>
                  <p>คะแนนเต็ม</p>
                  <p>คะแนนที่ได้</p>
                  <p>คะแนน (เปอร์เซ็นต์)</p>
                  <p>ตอบถูก</p>
                  <p>ตอบผิด</p>
                  <p>ไม่ได้ตอบ</p>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action class="subtitle-1 ma-0 text-right">
                <v-list-item-title>
                  <p class="grey--text">{{ exam.term + 1 }}</p>
                  <p class="grey--text">
                    {{ exam.created_at | moment("DD/MM/YYYY") }}&nbsp;
                    {{ new Date(exam.created_at).toString().substr(16, 2) + ":"
                    }}{{
                      new Date(exam.created_at).toString().substr(19, 2) + " น."
                    }}
                  </p>

                  <p>{{ exam.maxScore + " คะแนน" }}</p>

                  <p>
                    {{ exam.score + " คะแนน" }}
                  </p>
                  <p>
                    {{ ((exam.score / exam.maxScore) * 100).toFixed(2) + "%" }}
                  </p>
                  <p class="success--text">
                    {{ exam.correct + " ข้อ" }}
                  </p>
                  <p class="error--text">
                    {{ exam.wrong + " ข้อ" }}
                  </p>
                  <p class="grey--text">
                    {{ exam.noAnswer + " ข้อ" }}
                  </p>
                </v-list-item-title>
              </v-list-item-action>
            </v-list-item>
          </v-card>
        </div>
        <!-- <div class="box">
          <h3 class="black-text">สถิติการสอบโดยรวม</h3>
          <ul class="general-list center">
            <li>
              <p>
                <span>จำนวนผู้เข้าสอบ</span>
                <span>{{ detail.rankstat.numplayer }} คน</span>
              </p>
            </li>
            <li>
              <p>
                <span>คะแนนเต็ม</span>
                <span>{{ detail.totalScore }} คะแนน</span>
              </p>
            </li>
            <li>
              <p>
                <span>คะแนนสูงสุด</span>
                <span>{{ detail.rankstat.max }} คะแนน</span>
              </p>
            </li>
            <li>
              <p>
                <span>คะแนนต่ำสุด</span>
                <span
                  >{{ detail.rankstat.min }} {{ detail.myTicket }}คะแนน</span
                >
              </p>
            </li>
            <li>
              <p>
                <span>คะแนนเฉลี่ย</span>
                <span
                  >{{
                    detail.rankstat.mean % 1 === 0
                      ? detail.rankstat.mean
                      : detail.rankstat.mean.toFixed(2)
                  }}
                  คะแนน</span
                >
              </p>
            </li>
          </ul>
        </div> -->
        <!-- <div class="box">
          <h3 class="black-text">ประวัติการสอบของฉัน</h3>
          <ul class="general-list center">
            <li>
              <p>
                <span>คะแนนสูงสุด</span>
                <span>{{ getMaxScore(myTicket) }} คะแนน</span>
              </p>
            </li>
            <li>
              <p>
                <span>คะแนนต่ำสุด</span>
                <span>{{ getMinScore(myTicket) }} คะแนน</span>
              </p>
            </li>
            <li>
              <p>
                <span>คะแนนล่าสุด</span>
                <span>{{ getLastScore(myTicket) }} คะแนน</span>
              </p>
            </li>
            <li>
              <p>
                <span>จำนวนครั้งที่สอบ</span>
                <span>{{ myTicket.length }} ครั้ง</span>
              </p>
            </li>
          </ul>
        </div> -->
        <!-- <div class="box">
          <ul class="general-list with-progress vertical">
            <li>
              <p>
                <span class="description">ครั้งที่ 1</span>
                <span>24</span>
              </p>
              <span class="progress" style="height: 12%;"></span>
            </li>
            <li>
              <p>
                <span class="description">ครั้งที่ 2</span>
                <span>24</span>
              </p>
              <span class="progress" style="height: 20%;"></span>
            </li>
            <li>
              <p>
                <span class="description">ครั้งที่ 3</span>
                <span>24</span>
              </p>
              <span class="progress" style="height: 30%;"></span>
            </li>
            <li>
              <p>
                <span class="description">ครั้งที่ 4</span>
                <span>24</span>
              </p>
              <span class="progress" style="height: 50%;"></span>
            </li>
            <li>
              <p>
                <span class="description">ครั้งที่ 5</span>
                <span>24</span>
              </p>
              <span class="progress" style="height: 30%;"></span>
            </li>
            <li>
              <p>
                <span class="description">ครั้งที่ 6</span>
                <span>24</span>
              </p>
              <span class="progress" style="height: 25%;"></span>
            </li>
            <li>
              <p>
                <span class="description">ครั้งที่ 7</span>
                <span>24</span>
              </p>
              <span class="progress" style="height: 25%;"></span>
            </li>
          </ul>
        </div>-->
      </section>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import VueApexCharts from "vue-apexcharts";
export default {
  components: {
    apexchart: VueApexCharts,
  },

  data: () => ({
    examAvgSeries: [
      {
        name: "คะแนน ",
        data: [],
      },
    ],
    examAvgChartOptions: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          tools: {
            download: false,
          },
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "30%",
        },
      },
      colors: [],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: false,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [],
        title: {
          text: "No. of Examination",
        },
      },
      yaxis: {
        min: 0,
        max: 100,
        tickAmount: 4,
        title: {
          text: "Score (%)",
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val + "%";
          },
        },
        x: {
          formatter: function (val) {
            return val;
          },
        },
      },
    },
  }),
  computed: {
    buttonColor() {
      return Vue.prototype.$userInfo.companies[0].buttonColor;
    },
    headerColor() {
      return Vue.prototype.$userInfo.companies[0].headerColor;
    },
    dialogClassName() {
      return `dialog ${this.$store.getters.dialogExamClass}`;
    },
    hasExam() {
      return !!this.$store.getters.exam;
    },
    detail() {
      return this.$store.getters.exam.detail;
    },
    myTicket() {
      this.examAvgSeries[0].data = [];
      this.examAvgChartOptions.xaxis.categories = [];
      this.examAvgChartOptions.colors = [];

      let seriesColors = [];
      let xAxisCat = [];

      // console.log(this.$store.getters.exam.myTicket);
      let myTickets = this.$store.getters.exam.myTicket.slice().reverse();

      for (const myticket of myTickets) {
        this.examAvgSeries[0].data.push(
          ((myticket.score / myticket.maxScore) * 100).toFixed(2)
        );
        xAxisCat.push("ครั้งที่ " + (myticket.term + 1));
        seriesColors.push(
          Vue.prototype.$userInfo.companies[0].headerColor
        );
      }

      // this.examAvgChartOptions.xaxis.categories
      // this.examAvgChartOptions.colors

      let newSeries = this.examAvgSeries[0].data;
      this.examAvgSeries = [
        {
          name: "คะแนน ",
          data: newSeries,
        },
      ];
      this.examAvgChartOptions = {
        ...this.examAvgChartOptions,
        ...{
          xaxis: {
            categories: xAxisCat,
          },
          colors: seriesColors,
        },
      };
      // console.log(this.examAvgSeries, this.examAvgChartOptions);
      return this.$store.getters.exam.myTicket;
    },
    title() {
      return this.detail.title;
    },
    ticketId() {
      return this.$store.getters.ticketId;
    },
    statusCode() {
      return this.$store.getters.statusCode;
    },
    buttonCloseColor() {
      return "white";
    },
    iconCloseColor() {
      return Vue.prototype.$userInfo.companies[0].buttonColor;
    },
  },
  methods: {
    close() {
      this.$store.commit("setDialogExamClass", "close");
      setTimeout(() => {
        this.$store.commit("setDialogExamClass", "");
      }, 500);
    },
    goToExamWeb() {
      this.$store.dispatch("goToExamWeb");
      this.close();
    },
    millisecToHr(time) {
      // console.log(time);
      if (time) {
        let totalSeconds = time / 1000;
        let hours = Math.floor(totalSeconds / 3600);
        totalSeconds %= 3600;
        let minutes = Math.floor(totalSeconds / 60);
        let seconds = totalSeconds % 60;

        hours = hours < 10 ? `0${hours}` : `${hours}`;
        minutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
        seconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
        return `${hours}:${minutes}:${seconds}`;
      } else {
        return "00:00:00";
      }
    },
    getMinScore(scoreArr) {
      if (scoreArr.length == 0) return 0;
      return scoreArr.reduce(
        (min, p) => (p.score < min ? p.score : min),
        Infinity
      );
    },
    getMaxScore(scoreArr) {
      if (scoreArr.length == 0) return 0;
      return scoreArr.reduce((max, p) => (p.score > max ? p.score : max), 0);
    },
    getAvg(scoreArr) {
      if (scoreArr.length == 0) return 0;
      return scoreArr.reduce((a, b) => a + b.score) / scoreArr.length;
    },
    getLastScore(scoreArr) {
      if (scoreArr.length == 0) return 0;
      return scoreArr[0].score || 0;
      // return scoreArr[scoreArr.length - 1].score;
    },
  },
};
</script>
<style scoped lang="scss">
.black-text {
  color: black;
}
.detail {
  width: 100%;
}
#chart {
  max-width: 650px;
  margin: 35px auto;
}
</style>